import { Trainer } from '../../../common/networking/trainers'

export const findMatchingTrainers = (trainers: Trainer[]) =>
  trainers.filter(
    (trainer) =>
      trainer.id &&
      !trainer.archived &&
      trainer.approvedPrograms.onlineApproved,
  )
